<div class="page-header">
  <div class="header-top">
    <div class="menu-icon-wrapper" (click)="openSidenav()">
      <i class="material-icons">menu</i>
    </div>
    <app-shared-breadcrumb></app-shared-breadcrumb>
    <div class="header-actions">

      <ng-container *hasPermission="PermissionForStudents.NOTIFICATION_VIEW">
        <div class="icon-wrapper" (click)="toggleDropdown('notification', $event)">
          <i class="material-icons">notifications_none</i>
          <span class="badge">{{totalNotificationCount}}</span>

          <div class="dropdown notifications" *ngIf="showNotification">
            <div class="dropdown-header">
              <div class="left">
                <h4>All Notifications</h4>
              </div>
              <button class="mark-all" (click)="markAllNotificationsAsRead()"
                *hasPermission="PermissionForStudents.NOTIFICATION_MARK_AS_READ">Mark all read</button>
            </div>

            <div class="spinner-wrapper" *ngIf="isLoading">
              <mat-spinner diameter="40"></mat-spinner>
            </div>

            <ng-container *ngIf="!isLoading && studentNotifications.length > 0">
              <div class="notification-list">
                <div class="notification-item" *ngFor="let notification of studentNotifications"
                  [class.unread]="!notification.is_read" (click)="onNotificationClick(notification)"
                  [ngClass]="'card-' + notification.content_type.toLowerCase()">

                  <div class="icon" [ngClass]="'icon-' + notification.content_type.toLowerCase()">
                    <i class="material-icons">{{ getNotificationIcon(notification.content_type) }}</i>
                  </div>
                  <div class="text">
                    <h5>{{ notification.title }}</h5>
                    <h6>{{notification.message}}</h6>
                    <div class="time">
                      <i class="material-icons">access_time</i>{{ notification.created_at | istDate }}
                    </div>
                  </div>
                  <span class="dot" *ngIf="!notification.is_read"></span>
                </div>
              </div>
            </ng-container>

            <div class="empty-state" *ngIf="!isLoading && studentNotifications.length === 0">
              <i class="material-icons">notifications_off</i>
              <p>No notifications available</p>
            </div>

            <button class="view-all" (click)="goToStudentNotifications()"
              *hasPermission="PermissionForStudents.NOTIFICATION_VIEW">
              View All Notifications <i class="material-icons">open_in_new</i>
            </button>
          </div>
        </div>
      </ng-container>

      <button class="profile-btn" (click)="toggleProfileMenu() ; $event.stopPropagation()">
        <img src="assets/images/avatar.png" alt="avatar" class="profile-circle" />
      </button>

      <div class="profile-dropdown" *ngIf="isProfileMenuOpen">
        <div class="profile-header" *ngIf="userDetail">
          <p class="name">{{ userDetail.first_name }} {{userDetail.last_name}}</p>
          <p class="email" [matTooltip]="userDetail.phone_email">
            {{ userDetail.phone_email.length > 20 ? (userDetail.phone_email | slice: 0 :20) + '...'
            :userDetail.phone_email }}</p>
        </div>

        <div class="divider"></div>

        <button class="menu-item" (click)="goToProfile()">
          <i class="bi bi-person"></i>
          <span>My Profile</span>
        </button>

        <button type="button" class="menu-item" *ngIf="!isMentor" (click)="goToSubscription()">
          <i class="bi bi-gem"></i>
          <span>Subscription Plans</span>
        </button>



        <button class="menu-item" (click)="goToPayment()"
          *ngIf="!isMentor">
          <i class="bi bi-credit-card"></i>
          <span>Payment & Billing</span>
        </button>

        <div class="divider"></div>

        <button class="menu-item logout" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </div>
</div>